import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2;

import styled from 'styled-components';
import UIImage from 'UIComponents/image/UIImage';
import FormattedMessage from 'I18n/components/FormattedMessage'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message

import { ProductLinePageIcons } from 'ui-addon-upgrades/_core/productPage/ProductPageIcons';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import { H1 } from 'UIComponents/elements/headings';
import { NavItemEnum } from '../../constants/routing/NavItems';
export const ProductPageHeader = styled.header.withConfig({
  displayName: "ProductPageTitle__ProductPageHeader",
  componentId: "sc-1tuldfv-0"
})(["display:flex;flex-direction:column;width:100%;align-items:center;", ""], breakpoint.tabletPortrait(_t || (_t = _`
      padding: 0 3%;
    `)));
const StyledTitle = styled(H1).withConfig({
  displayName: "ProductPageTitle__StyledTitle",
  componentId: "sc-1tuldfv-1"
})(["color:#33475b;font-size:2rem;text-align:center;display:flex;align-items:center;min-height:44px;margin-bottom:8px;", ";"], breakpoint.cs(_t2 || (_t2 = _`
    margin-top: 0;
    justify-content: center;
  `)));
const Trademark = styled.span.withConfig({
  displayName: "ProductPageTitle__Trademark",
  componentId: "sc-1tuldfv-2"
})(["font-weight:200;font-size:70%;"]);

const ProductPageTitle = ({
  productLine,
  nonProductIdentifier
}) => {
  const tradeMarkMap = {
    [MARKETING]: {
      includeTrademark: true
    },
    [SALES]: {
      includeRegisteredTrademark: true
    },
    [SERVICE]: {
      includeTrademark: true
    },
    [CMS]: {
      includeRegisteredTrademark: true
    },
    [OPERATIONS]: {
      includeRegisteredTrademark: true
    }
  };
  const translationKeyMap = {
    [MARKETING]: 'pricingPage.pages.products.tabs.marketing.pageTitle',
    [SALES]: 'pricingPage.pages.products.tabs.sales.pageTitle',
    [SERVICE]: 'pricingPage.pages.products.tabs.service.pageTitle',
    [CMS]: 'pricingPage.pages.products.tabs.cms.pageTitle',
    [OPERATIONS]: 'pricingPage.pages.products.tabs.operations.pageTitle',
    [NavItemEnum.BUNDLE]: 'pricingPage.pages.products.tabs.bundle.pageTitle',
    [NavItemEnum.FREE]: 'pricingPage.pages.products.tabs.crm.pageTitle',
    [NavItemEnum.SUITE]: 'pricingPage.pages.products.tabs.suite.pageTitle'
  };
  return /*#__PURE__*/_jsxs(StyledTitle, {
    "aria-level": 1,
    children: [productLine && /*#__PURE__*/_jsx(UIImage, {
      className: "display-inline m-right-3",
      src: ProductLinePageIcons[productLine]
    }), productLine && /*#__PURE__*/_jsx(FormattedMessage, {
      message: translationKeyMap[productLine]
    }), nonProductIdentifier && /*#__PURE__*/_jsx(FormattedMessage, {
      message: translationKeyMap[nonProductIdentifier]
    }), productLine && tradeMarkMap[productLine].includeTrademark && /*#__PURE__*/_jsx(Trademark, {
      children: "\u2122"
    }), productLine && tradeMarkMap[productLine].includeRegisteredTrademark && /*#__PURE__*/_jsx(Trademark, {
      children: "\xAE"
    })]
  });
};

export default ProductPageTitle;